import logoColor from '@/assets/images/midani-logo-color.png';

// Brand block info shown at the top of the sidebar.
export const appBrand = {
  name: 'Midani',
  subtitle: 'Dev – Web App',
  logoUrl: logoColor,
};
